@if (modalService.showModal()) {
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events,@angular-eslint/template/interactive-supports-focus -->
    <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-surface-900/50 backdrop-blur-[2px] p-4 animate-fade-in"
        (click)="onBackdropClick($event)"
        role="presentation"
    >
        <div
            #dialog
            class="bg-white rounded-2xl shadow-soft-lg max-w-sm w-full p-5 animate-scale-in"
            role="dialog"
            aria-modal="true"
            aria-labelledby="justify-title"
        >
            <div class="flex justify-center mb-3">
                <div
                    class="size-12 rounded-xl bg-danger-50 text-danger-600 flex items-center justify-center"
                    aria-hidden="true"
                >
                    <i class="fa-solid fa-pen-to-square text-xl"></i>
                </div>
            </div>

            <h3
                id="justify-title"
                class="text-lg font-semibold text-surface-900 text-center font-display mb-1"
            >
                Justification requise
            </h3>
            <p class="text-surface-500 text-center text-sm mb-3.5">
                Ce rendez-vous exige un motif d'excuse
            </p>

            @if (modalService.modalConfig(); as config) {
                <div
                    class="flex items-center gap-2 px-3 py-2 bg-surface-50 rounded-lg border border-surface-100 mb-3.5"
                >
                    <i
                        class="fa-solid fa-calendar-day text-primary-500 text-xs"
                        aria-hidden="true"
                    ></i>
                    <span class="text-surface-700 text-sm font-medium">
                        {{ config.appointmentLabel }}
                    </span>
                </div>
            }

            <label for="justification-reason" class="label">
                Motif de l'excuse
            </label>
            <textarea
                id="justification-reason"
                [(ngModel)]="reason"
                [maxlength]="maxLength"
                class="input resize-none min-h-[5rem]"
                rows="3"
                placeholder="Expliquez brièvement…"
                aria-describedby="justify-counter justify-info"
            ></textarea>
            <p
                id="justify-counter"
                class="text-right text-2xs text-surface-400 mt-1 mb-3"
            >
                {{ reason.length }} / {{ maxLength }}
            </p>

            <div
                id="justify-info"
                class="flex items-start gap-2 px-3 py-2 bg-accent-50 rounded-lg border border-accent-100 mb-4"
            >
                <i
                    class="fa-solid fa-circle-info text-accent-700 text-xs mt-0.5"
                    aria-hidden="true"
                ></i>
                <span class="text-xs text-accent-800">
                    Votre excuse sera soumise au secrétaire pour validation.
                </span>
            </div>

            <div class="flex gap-2">
                <button
                    type="button"
                    (click)="onCancel()"
                    class="btn-secondary flex-1"
                >
                    Annuler
                </button>
                <button
                    type="button"
                    (click)="onConfirm()"
                    [disabled]="!canSubmit"
                    class="btn-danger flex-1"
                >
                    Envoyer
                </button>
            </div>
        </div>
    </div>
}
